var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRemove = function SvgRemove(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "delete")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(6.000000, 6.000000)",
    fill: "#979797",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,24.6666667 C18.9956068,24.6666667 24.6666667,18.9956068 24.6666667,12 C24.6666667,5.00439317 18.9956068,-0.666666667 12,-0.666666667 C5.00439317,-0.666666667 -0.666666667,5.00439317 -0.666666667,12 C-0.666666667,18.9956068 5.00439317,24.6666667 12,24.6666667 Z M12,23.3333333 C5.74077284,23.3333333 0.666666667,18.2592272 0.666666667,12 C0.666666667,5.74077284 5.74077284,0.666666667 12,0.666666667 C18.2592272,0.666666667 23.3333333,5.74077284 23.3333333,12 C23.3333333,18.2592272 18.2592272,23.3333333 12,23.3333333 Z",
    id: "Oval"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3333333,10.6666667 L6.66666667,10.6666667 C5.930287,10.6666667 5.33333333,11.2636203 5.33333333,12 C5.33333333,12.7363797 5.930287,13.3333333 6.66666667,13.3333333 L17.3333333,13.3333333 C18.069713,13.3333333 18.6666667,12.7363797 18.6666667,12 C18.6666667,11.2636203 18.069713,10.6666667 17.3333333,10.6666667 Z",
    id: "Line"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRemove, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/remove.8626f530.svg";
export { ForwardRef as ReactComponent };